/*
 * @Author: your name
 * @Date: 2022-04-22 22:56:24
 * @LastEditTime: 2022-04-22 23:48:06
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \rcd-wap\src\utils\convert-service copy.js
 */

/**
 * 查找对应属性的值
 * @returns 
 */
Array.prototype.Select = function (fields) {
    if(!fields) return this
    var list = []
    for (var i = 0; i < this.length; i++) {
        var obj = {}
        Object.keys(this[i]).forEach(key=> {
            let index = fields.findIndex(e=> e == key)
            if(index != -1) {
                if(fields.length == 1) {
                    list.push(this[i][key])
                }
                else
                {
                    obj[key] = this[i][key]
                    console.log(obj)
                }
            }
        })
        if(fields.length > 1) {
            list.push(obj)
        }
    }
    return list 
}